module.exports = __webpack_public_path__ + "img/5.c0ab8c65.jpg";